import { Palette } from "../../constants.js";
const palette = {
  // @ts-ignore
  primary: {
    main: Palette.DARK_PURPLE,
    dark: Palette.DARKER_PURPLE,
    contrastBackground: Palette.WHITE,
    contrastText: Palette.WHITE,
    background: Palette.DARK_PURPLE_LIGHTER_TRANSPARENT,
    border: Palette.DARK_PURPLE
  },
  secondary: {
    main: Palette.VIOLET,
    dark: Palette.DARKER_VIOLET,
    light: Palette.VIOLET_TRANSPARENT,
    contrastBackground: Palette.WHITE,
    contrastText: Palette.WHITE,
    background: Palette.VIOLET_LIGHTER_TRANSPARENT,
    backgroundAlternate: Palette.LIGHT_VIOLET_TRANSPARENT,
    border: Palette.VIOLET
  },
  text: {
    primary: Palette.DARKER_GRAY,
    secondary: Palette.DARKER_GRAY,
    disabled: Palette.DARK_GRAY
  },
  // @ts-ignore
  success: {
    main: Palette.DARK_GREEN,
    border: Palette.DARK_GREEN,
    background: Palette.GREEN_TRANSPARENT
  },
  // @ts-ignore
  error: {
    main: Palette.RED,
    border: Palette.RED,
    background: Palette.RED_TRANSPARENT,
    contrastText: Palette.WHITE
  },
  // @ts-ignore
  warning: {
    dark: Palette.ORANGE,
    main: Palette.TANGERINE,
    background: Palette.TANGERINE_TRANSPARENT,
    contrastText: Palette.WHITE
  },
  // @ts-ignore
  info: {
    main: Palette.VIOLET,
    border: Palette.VIOLET,
    background: Palette.VIOLET_LIGHTER_TRANSPARENT
  },
  // @ts-ignore
  neutral: {
    dark: Palette.DARK_GRAY,
    main: Palette.GRAY,
    light: Palette.LIGHT_GRAY,
    background: Palette.WHITE,
    backgroundUnchecked: Palette.LIGHT_GRAY
  }
};
export {
  palette as ThemePalette,
  palette
};
//# sourceMappingURL=paletteTheme.js.map
